import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { color } from '@metro-ui/tokens/js';
import { BasicTableCheckbox } from './BasicTableCheckbox';
import { BasicTableHeadCell } from './BasicTableHeadCell';
export var BasicTableHead = styled(function (_a) {
    var children = _a.children, checkbox = _a.checkbox, props = __rest(_a, ["children", "checkbox"]);
    return (React.createElement("thead", __assign({}, props),
        React.createElement("tr", null,
            !!checkbox && (React.createElement(BasicTableCheckbox, __assign({ Component: BasicTableHeadCell }, checkbox))),
            children)));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), color.contrast.white);
BasicTableHead.propTypes = {
    checkbox: PropTypes.shape({
        id: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
    }),
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=BasicTableHead.js.map